import Vue from 'vue'

import CkIcon from '@/components/kit/CkIcon'
import HeadingSubtitle from '@/components/shared-layout/HeadingSubtitle'

import ButtonColorDiv from '@/components/styledcomponents/ButtonColorDiv'
import AbsoluteDiv from '@/components/styledcomponents/AbsoluteDiv'
import ColorDiv from '@/components/styledcomponents/ColorDiv'
import ColorSection from '@/components/styledcomponents/ColorSection'
import ColorSpan from '@/components/styledcomponents/ColorSpan'
import FlexChildDiv from '@/components/styledcomponents/FlexChildDiv'
import FlexChildSpan from '@/components/styledcomponents/FlexChildSpan'
import FlexDiv from '@/components/styledcomponents/FlexDiv'
import PaddingDiv from '@/components/styledcomponents/PaddingDiv'
import Paragraph from '@/components/styledcomponents/Paragraph'

import EnergyVisualisationGradient from '@/components/pages/energy/EnergyVisualisationGradient'

Vue.component('ck-icon', CkIcon)
Vue.component('heading-subtitle', HeadingSubtitle)

Vue.component('absolute', AbsoluteDiv)
Vue.component('color', ColorDiv)
Vue.component('color-span', ColorSpan)
Vue.component('color-section', ColorSection)
Vue.component('button-color', ButtonColorDiv)
Vue.component('flex-child', FlexChildDiv)
Vue.component('flex-child-span', FlexChildSpan)
Vue.component('flex', FlexDiv)
Vue.component('padding', PaddingDiv)
Vue.component('paragraph', Paragraph)

Vue.component('energy-visualisation-gradient', EnergyVisualisationGradient)
